import { makeAutoObservable } from 'mobx'
import * as Cesium from '@cesiumgs/cesium-analytics'
import type { Cesium3DTileset, Viewer } from '@cesiumgs/cesium-analytics'
import {
  ILoad3dTiles, ILoadWMTS, getBuildInfo, getBusinessInfo, getDlngList, getEnvironmentInfo, getFacilityInfo,
  getFcltDetail, getFcltList, getPopulationInfo, getPrteFarmStyiList,
  getPrteFarmTurmList, getTrafficInfo,
} from '@/service/facility'

export const CUSTOM_3DTILESET_ID = '3d-tiles-facility'
interface CustomCesium3DTileset extends Cesium3DTileset {
  customId?: string
}
export class FacilityStore {
  SearchLoding = false
  SearchResultShow = false
  SearchResults: Array<any> = []
  FacilityResultsCount = 0
  FacilityLeaseShow = false
  FacilityLeaseInfo: any = null
  FacilityInfoObj: any | null = null

  FacilityInfoShow = false
  FacilityLeaseCardInfo: Array<any> | null = null
  // FacilityTileset: Cesium3DTileset | null = null
  FacilityTileset: CustomCesium3DTileset | null = null
  FacilityTileset1: CustomCesium3DTileset | null = null
  FacilityTileset2: CustomCesium3DTileset | null = null
  isOpendTabsPage = false
  idlFcltUnqNo: null | string = null
  modeLoadedTileset = '' // tileset 로딩이 완료되면 설정. facility / lod1. overlab 체크 위함

  WMTSImgLayer: any = null
  hideProvinceEntityNum = 0

  clickedSggCd = ''
  searchParams: any = null
  clickedLonLat: any = null

  posFclt: { x: number; y: number } | null = null

  constructor() {
    makeAutoObservable(this)
  }

  // 유휴시설 클릭 시 선택한 x, y 좌표정보 업데이트
  setPosFclt(newPosFclt: { x: number; y: number } | null) {
    this.posFclt = newPosFclt
  }

  async searchFacility(params: any) {
    this.SearchLoding = true
    this.FacilityLeaseShow = false
    this.FacilityInfoShow = false
    this.isOpendTabsPage = false
    let data: any = null
    this.searchParams = params
    console.log('params', params)
    try {
      data = await getFcltList(params)
    }
    catch (error) {
      this.SearchLoding = false
    }
    const arr: Array<object> = []
    if (data.code === 200) {
      this.FacilityResultsCount = data.result.totalCnt
      if (data.result.resultList.length > 0) {
        // eslint-disable-next-line array-callback-return
        data.result.resultList.map((item: any) => {
          const tagArray = item.prueSeCdNm === null ? [] : item.prueSeCdNm.split(',')
          const tag2 = tagArray.length >= 4 ? ['전체'] : tagArray
          // Add item.dodcd to the footerTag array
          const footerTagArray = item.htag === null ? [] : item.htag.split(',')
          if (item.dodCd) {
            footerTagArray.push(item.dodCd)
          }

          arr.push({
            ...item,
            tag: tag2,
            name: item.fcltNm,
            addr: `${item.bdar}m²/${item.useAprvYmd}/${item.bldgFlrCnt}층/${item.museCdNm}`,
            imgSrc: item.rprsImgFilePath,
            footerTag: footerTagArray,
            idlFcltUnqNo: item.idlFcltUnqNo,
          })
        })

        this.SearchResults = arr
        this.SearchResultShow = true
      }
      else {
        this.SearchResultShow = false
      }
      this.SearchLoding = false
    }

    else {
      this.SearchLoding = false
      this.SearchResultShow = true
      this.FacilityResultsCount = 0
    }
  }

  facilityResultsClean(viewer: Viewer) {
    this.SearchResultShow = false
    this.FacilityResultsCount = 0
    if (this.SearchLoding) {
      this.SearchLoding = false
    }
    this.FacilityLeaseShow = false
    this.isOpendTabsPage = false
    this.FacilityInfoShow = false
    this.FacilityLeaseInfo = null
    this.FacilityLeaseCardInfo = null
    if (this.FacilityTileset !== null && viewer !== null) {
      viewer.scene.primitives.remove(this.FacilityTileset)
      this.FacilityTileset = null
    }
  }

  facilityLeaseHide() {
    this.FacilityLeaseShow = !this.FacilityLeaseShow
  }

  facilityInfoHide() {
    this.FacilityInfoShow = !this.FacilityInfoShow
  }

  showFacilityInfo(flag: boolean) {
    this.FacilityLeaseShow = flag
  }

  async getFacilityLeaseInfo(idlFcltUnqNo: string, id: string) {
    if (this.FacilityInfoShow) {
      this.FacilityInfoShow = false
    }
    const data: any = await getFcltDetail(idlFcltUnqNo, id)
    if (data.code === 200) {
      const results = data.result

      // Add item.dodcd to the footerTag array
      const footerTagArray = results.htag === null ? [] : results.htag.split(',')
      if (results.dodCd) {
        footerTagArray.push(results.dodCd)
      }

      this.FacilityLeaseInfo = {
        ...results,
        tag: results.prueSeCdNm === null ? [] : results.prueSeCdNm.split(','),
        name: results.fcltNm,
        addr1: `(도로명)${results.roadNmAddr}`,
        addr2: `(지번)${results.lotnoAddr}`,
        info: `${results.bdar}m²/${results.useAprvYmd}/${results.bldgFlrCnt}층/${results.museCdNm}`,
        imgSrc: results.rprsImgFilePath,
        footerTag: footerTagArray,
        bldgFlrCnt: results.bldgFlrCnt,
        sggCd: results.sggCd,
        dodCd: results.dodCd,
        idlFcltUnqNo: results.idlFcltUnqNo,
        posFclt: { x: results.x, y: results.y },
      }
      const arr: Array<object> = []
      if (results.itspList.length > 0) {
        results.itspList.forEach((item: any) => {
          arr.push({
            imgSrc: item.rprsImgFilePath,
            name: `${item.flrNo}층` + ' ' + `${item.hoCnt}호` + ' ' + `${item.numrNm}`,
            info1: `${item.ar}㎡`,
            info2: item.itspSeCdNm,
            idlFcltUnqNo: item.idlFcltUnqNo,
            flrNo: item.flrNo,
            hoCnt: item.hoCnt,
            brtitleinfoUnqNo: item.brtitleinfoUnqNo,
          })
        })
        this.FacilityLeaseCardInfo = arr
      }
    }
    this.FacilityLeaseShow = true
    this.FacilityInfoObj = null
  }

  getFacilityInfo(imgSrc: string, name: string, info1: string, info2: string, idlFcltUnqNo: string, flrNo: string, hoCnt: string, brtitleinfoUnqNo: string) {
    this.FacilityInfoObj = {
      imgSrc,
      name,
      info1,
      info2,
      idlFcltUnqNo,
      flrNo,
      hoCnt,
      brtitleinfoUnqNo,
    }
    this.FacilityInfoShow = true
    if (this.isOpendTabsPage) {
      this.isOpendTabsPage = false
    }
  }

  async queryBuildInfo(id: string) {
    return await getBuildInfo(this.FacilityInfoObj, id)
  }

  async queryDlngList() {
    return await getDlngList(this.FacilityInfoObj)
  }

  async queryPopulationInfo() {
    return await getPopulationInfo(this.FacilityLeaseInfo)
  }

  async queryEnvironmentInfo() {
    return await getEnvironmentInfo(this.FacilityLeaseInfo)
  }

  async queryFacilityInfo() {
    return await getFacilityInfo(this.FacilityLeaseInfo)
  }

  async queryTrafficInfo() {
    return await getTrafficInfo(this.FacilityLeaseInfo)
  }

  async queryBusinessInfo() {
    return await getBusinessInfo({ sidoCd: 35 })
  }

  async queryPrteFarmTurmInfo() {
    return await getPrteFarmTurmList(this.FacilityLeaseInfo)
  }

  async queryPrteFarmStyInfo() {
    return await getPrteFarmStyiList(this.FacilityLeaseInfo)
  }

  loadTileset(viewer: Viewer, url: string, type: string) {
    if (this.FacilityTileset !== null) {
      if (type === '78') {
        viewer.scene.primitives.remove(this.FacilityTileset)
        viewer.scene.primitives.remove(this.FacilityTileset1)
        viewer.scene.primitives.remove(this.FacilityTileset2)
      }
      else {
        viewer.scene.primitives.remove(this.FacilityTileset)
      }
    }
    if (this.WMTSImgLayer !== null) {
      viewer.imageryLayers.remove(this.WMTSImgLayer)
    }
    if (type === '78') {
      this.FacilityTileset = new Cesium.Cesium3DTileset({
        url: Cesium.IonResource.fromAssetId(2336108),
      })
      this.FacilityTileset1 = new Cesium.Cesium3DTileset({
        url: Cesium.IonResource.fromAssetId(2336112),
      })
      this.FacilityTileset2 = new Cesium.Cesium3DTileset({
        url: Cesium.IonResource.fromAssetId(2341726),
      })
      this.FacilityTileset.customId = CUSTOM_3DTILESET_ID
      this.FacilityTileset1.customId = CUSTOM_3DTILESET_ID
      this.FacilityTileset2.customId = CUSTOM_3DTILESET_ID
      viewer.scene.primitives.add(this.FacilityTileset)
      viewer.scene.primitives.add(this.FacilityTileset1)
      viewer.scene.primitives.add(this.FacilityTileset2)
      viewer.flyTo(this.FacilityTileset, {
        offset: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-30),
          range: 100,
        },
      })
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const provider = new Cesium.WebMapTileServiceImageryProvider({
        url: `${window.SystemConfig.lod1}/static/tiles/Resouce/Admin/20231113/191258/{TileMatrix}/{TileCol}/{TileRow}.png`,
      })
      this.WMTSImgLayer = new Cesium.ImageryLayer(provider)
      viewer.imageryLayers.add(this.WMTSImgLayer)
    }
    else if (type === '39') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const provider = new Cesium.WebMapTileServiceImageryProvider({
        url: `${window.SystemConfig.ndTileServer}/static/tiles/resouce/user/20231204/1701652167295/{TileMatrix}/{TileCol}/{TileRow}.png`,
      })
      this.WMTSImgLayer = new Cesium.ImageryLayer(provider)
      viewer.imageryLayers.add(this.WMTSImgLayer)
    }
    else {
      this.FacilityTileset = new Cesium.Cesium3DTileset({
        url,
      })
      this.FacilityTileset.customId = CUSTOM_3DTILESET_ID
      viewer.scene.primitives.add(this.FacilityTileset)
      viewer.flyTo(this.FacilityTileset, {
        offset: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-30),
          range: 100,
        },
      })
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const provider = new Cesium.WebMapTileServiceImageryProvider({
        url: `${window.SystemConfig.lod1}/static/tiles/Resouce/Admin/20230703/184737/{TileMatrix}/{TileCol}/{TileRow}.png`,
      })
      this.WMTSImgLayer = new Cesium.ImageryLayer(provider)
      viewer.imageryLayers.add(this.WMTSImgLayer)
    }
  }

  // load3dTiles(viewer: Viewer, id: string) {
  //   ILoad3dTiles(id).then((res: any) => {
  //     const { data } = res
  //     if (data.code === 200) {
  //       if (Array.isArray(data.data) && data.data.length > 0) {
  //         if (this.FacilityTileset !== null) {
  //           viewer.scene.primitives.remove(this.FacilityTileset)
  //         }
  //         this.FacilityTileset = new Cesium.Cesium3DTileset({
  //           url: data.data[0].serviceUrl,
  //         })
  //         this.FacilityTileset.customId = CUSTOM_3DTILESET_ID
  //         // set the tileset height
  //         const heightOffset = Cesium.Cartesian3.fromElements(0, 0, 0)
  //         const translation = Cesium.Matrix4.fromTranslation(heightOffset)
  //         this.FacilityTileset.modelMatrix = translation
  //         // this.FacilityTileset.readyPromise.then((res: any) => {
  //         //   res.style = new Cesium.Cesium3DTileStyle({
  //         //     color: {
  //         //       conditions: [],
  //         //     },
  //         //     show: {
  //         //       conditions: [
  //         //         ['regExp("F1.*?").test(${3ds_mesh_name})', 'false'],
  //         //         ['regExp("F2.*?").test(${3ds_mesh_name})', 'true'],
  //         //       ],
  //         //     },
  //         //     meta: {
  //         //       description: '"it is floor"',
  //         //     },
  //         //   })
  //         // })
  //         viewer.scene.primitives.add(this.FacilityTileset)
  //         viewer.flyTo(this.FacilityTileset, {
  //           offset: {
  //             heading: Cesium.Math.toRadians(0),
  //             pitch: Cesium.Math.toRadians(-30),
  //             range: 100,
  //           },
  //         })
  //       }
  //     }
  //   })
  // }

  load3dTiles(viewer: Viewer, id: string) {
    // 이전에 존재하는 poi icon 초기화
    if (window.cviewer && window.cviewer.entities && window.cviewer.entities.values) {
      window.cviewer.entities.values.forEach((entity: any) => {
        if (window.cviewer.entities.values) {
          window.cviewer.entities.remove(entity)
        }
      })
    }

    ILoad3dTiles(id).then((res) => {
      const { data } = res
      if (data.code === 200) {
        // Tile 정보가 있을 때 로직
        if (Array.isArray(data.data) && data.data.length > 0 && data.data[0].serviceUrl.trim() !== '') {
          if (this.FacilityTileset !== null) {
            viewer.scene.primitives.remove(this.FacilityTileset)
          }
          this.FacilityTileset = new Cesium.Cesium3DTileset({
            url: data.data[0].serviceUrl,
          })
          this.FacilityTileset.customId = CUSTOM_3DTILESET_ID

          viewer.scene.primitives.add(this.FacilityTileset)

          this.FacilityTileset.readyPromise.then((tileset) => {
            // 타일셋의 시각적 경계를 기반으로 중심점을 계산
            const boundingSphere = tileset.boundingSphere
            const center = boundingSphere.center

            // 지표면에서의 높이를 얻기 위해, 중심점을 위도와 경도로 변환
            const cartographic = Cesium.Cartographic.fromCartesian(center)
            const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude)

            // 중심점에서 20미터 위의 위치 계산
            const heightOffset = 20 // 높이 오프셋 (미터 단위)
            const offsetPosition = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, cartographic.height + heightOffset)

            // poi 아이콘 추가
            viewer.entities.add({
              position: offsetPosition,
              billboard: {
                image: './Symbol/icon-fclt.png',
                scale: 2,
              },
            })

            // 카메라 이동은 유지
            viewer.flyTo(tileset, {
              offset: {
                heading: Cesium.Math.toRadians(0),
                pitch: Cesium.Math.toRadians(-30),
                range: 100,
              },
            })
          })
          // lod1과 검색의 시설물이 겹치는 경우, lod1의 모델을 숨김처리
          this.FacilityTileset.allTilesLoaded.addEventListener(() => {
            this.setModeTileset('facility')
          })
        }// 호출하는 유휴시설의 Tile 정보가 없다면 유휴시설 API 위치 정보에 poi 표출
        else if (Array.isArray(data.data) && data.data.length > 0 && data.data[0].serviceUrl.trim() === '') {
          if (this.posFclt && window.cviewer && window.cviewer.entities) {
            const { x, y } = this.posFclt
            const targetHeight = 20

            const terrainHeightPromise = Cesium.sampleTerrainMostDetailed(window.cviewer.terrainProvider, [
              Cesium.Cartographic.fromDegrees(x, y),
            ])
            terrainHeightPromise.then((updatedPositions) => {
              const terrainHeight = updatedPositions[0].height
              window.cviewer.entities.add({
                position: Cesium.Cartesian3.fromDegrees(x, y, terrainHeight + targetHeight),
                billboard: {
                  image: './Symbol/icon-fclt.png',
                  scale: 2,
                  verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                },
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              })

              window.cviewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(x, y, 200),
                offset: {
                  heading: Cesium.Math.toRadians(0),
                  pitch: Cesium.Math.toRadians(-30),
                  range: 100,
                },
              })
            })
          }
        }
      }
    })
  }

  load3dWMTS(viewer: Viewer, id: string) {
    ILoadWMTS(id).then((res: any) => {
      const { data } = res
      if (data.code === 200) {
        if (Array.isArray(data.data) && data.data.length > 0) {
          if (this.WMTSImgLayer !== null) {
            viewer.imageryLayers.remove(this.WMTSImgLayer)
          }
          const url = `${data.data[0].serviceUrl}/{TileMatrix}/{TileCol}/{TileRow}.png`
          const provider = new Cesium.WebMapTileServiceImageryProvider({
            url,
            layer: 'USGSShadedReliefOnly',
            style: 'default',
            format: 'image/png',
            tileMatrixSetID: 'default028mm',
            maximumLevel: 19,
          })
          this.WMTSImgLayer = new Cesium.ImageryLayer(provider)
          viewer.imageryLayers.add(this.WMTSImgLayer)
        }
      }
    })
  }

  flyToTilest(viewer: Viewer, type: string) {
    if (this.FacilityTileset) {
      switch (type) {
        case 'TopView':
          viewer.flyTo(this.FacilityTileset, {
            offset: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90),
              range: 500,
            },
          })
          break
        case 'AerialView':
          viewer.flyTo(this.FacilityTileset, {
            offset: {
              heading: Cesium.Math.toRadians(-30),
              pitch: Cesium.Math.toRadians(-60),
              range: 300,
            },
          })
          break
        case 'PlanningView':
          viewer.flyTo(this.FacilityTileset, {
            offset: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(0),
              range: 80,
            },
          })
          break
      }
    }
  }

  openTabsPage() {
    this.isOpendTabsPage = true
    if (this.FacilityInfoShow) {
      this.FacilityInfoShow = false
    }
  }

  closeCurrentPage() {
    this.isOpendTabsPage = !this.isOpendTabsPage
    this.FacilityInfoObj = null
  }

  setIdlFcltUnqNo(index: string | null) {
    this.idlFcltUnqNo = index
  }

  justClickToHide() {
    this.hideProvinceEntityNum = this.hideProvinceEntityNum + 1
  }

  setClickedSggCdValue(sggCd: string) {
    this.clickedSggCd = sggCd
  }

  setClickedLonLat(arr: [number, number]) {
    this.clickedLonLat = arr
  }

  setModeTileset(mode: string) {
    this.modeLoadedTileset = mode
  }
}
